module.exports = __webpack_public_path__ + "img/Trophy Cup Table07.63f02250.jpg";